import request from "@/util/request";
import sha256 from "sha256";

// 重置密码
export function resetPassword(data, password) {
	if (stage.loc.loginSystem.sha256) {
		password = sha256(password);
	}
	return request({
		url: `/user-s/acc/my/password/${password}`,
		method: "post",
		params: data,
	});
}
// 切换语言
export function changeLanguage(v) {
	let lan = stage.languageId;
	if (v) {
		lan = v;
	}
	return request({
		url: `/user-s/acc/my/language/${lan}`,
		method: "post",
	});
}

// 修改个人信息
export function editInfo(data) {
	return request({
		url: `/user-s/acc/my/info`,
		method: "post",
		data,
	});
}

// 修改邮箱
export function editEmail(data, email) {
	return request({
		url: `/user-s/acc/my/email/${email}`,
		method: "post",
		params: data,
	});
}

// 修改手机号
export function editPhoneNumber(data, countryCode, phoneNumber) {
	return request({
		url: `/user-s/acc/my/phone-number/${countryCode}/${phoneNumber}`,
		method: "post",
		params: data,
	});
}

// 修改密码
export function editPassword(oldPassword, newPassword) {
	if (stage.loc.loginSystem.sha256) {
		oldPassword = sha256(oldPassword);
		newPassword = sha256(newPassword);
	}
	return request({
		url: `/user-s/acc/my/password/${oldPassword}/${newPassword}`,
		method: "post",
	});
}

// 修改用户名
export function editUsername(username) {
	return request({
		url: `/user-s/acc/my/username`,
		method: "post",
		data: username,
	});
}

// 获取偏好设置
export function getconfig() {
	if (stage.useMode != "independentPage") {
		return request({
			url: `/user-s/acc/my/config`,
			method: "get",
		});
	}
}

// 更新偏好设置
export function updateconfig(data) {
	return request({
		url: `/user-s/acc/my/config `,
		method: "post",
		data,
	});
}



// WEBPACK FOOTER //
// ./src/api/setting/my.js